document.documentElement.classList.add('js');

function applyCatalogFilter(wanted, updateUrl) {
  const cards = document.querySelectorAll('[data-category]');
  if (!cards.length) return;
  let visible = 0;
  document.querySelectorAll('[data-filter]').forEach(el => el.classList.toggle('is-active', el.dataset.filter === wanted));
  cards.forEach(card => { const show = wanted === 'All' || card.dataset.category === wanted; card.hidden = !show; if (show) visible++; });
  const empty = document.querySelector('.catalog-empty');
  if (empty) empty.hidden = visible !== 0;
  if (updateUrl) {
    const url = new URL(window.location.href);
    wanted === 'All' ? url.searchParams.delete('category') : url.searchParams.set('category', wanted);
    url.hash = 'catalog';
    history.replaceState({}, '', url);
  }
}

function closeMenus() {
  document.body.classList.remove('menu-open', 'products-open');
  document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
  document.querySelector('[data-products-toggle]')?.setAttribute('aria-expanded', 'false');
}

document.addEventListener('DOMContentLoaded', () => {
  const selected = new URLSearchParams(window.location.search).get('category');
  if (selected) applyCatalogFilter(selected, false);
});

document.addEventListener('click', (event) => {
  const menuToggle = event.target.closest('[data-menu-toggle]');
  if (menuToggle) {
    const open = document.body.classList.toggle('menu-open');
    menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  const productsToggle = event.target.closest('[data-products-toggle]');
  if (productsToggle) {
    const open = document.body.classList.toggle('products-open');
    productsToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (event.target.matches('[data-overlay]')) closeMenus();
  const chip = event.target.closest('[data-filter]');
  if (chip) applyCatalogFilter(chip.dataset.filter, true);
  const categoryLink = event.target.closest('[data-category-link]');
  if (categoryLink && document.querySelector('#catalog')) {
    event.preventDefault();
    applyCatalogFilter(categoryLink.dataset.categoryLink, true);
    closeMenus();
    document.querySelector('#catalog').scrollIntoView({ behavior: 'smooth' });
  }
  if (!event.target.closest('.nav-products') && !menuToggle) document.body.classList.remove('products-open');
});

document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenus(); });
document.addEventListener('change', (event) => { if (!event.target.matches('[data-variant-select]')) return; const option=event.target.selectedOptions[0]; const form=event.target.closest('form'); if(form&&option) form.querySelector('[name="id"]').value=option.value; });
